import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { AuthService } from "../auth/auth.service";
import { HttpClient, HttpHeaders, HttpParams  } from "@angular/common/http";
import { AbortSignal } from 'abort-controller';
import { PessoaDebito } from "../model/pessoaDebitos";
import { MessageService } from 'primeng/api';



@Injectable()
export class PessoaDebitosService {

  private apiUrl = environment.api + environment.pessoa;

  constructor(protected authService:AuthService, 
              protected http: HttpClient,
              private messageService: MessageService) { }

  public async getPessoaDebitos(chave: string, detalhar: boolean, tipoDebito: string ): Promise<PessoaDebito> {
    const token = await this.authService.getAccessToken();

    const requestOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
    };

    const params = new HttpParams({
        fromObject: {
          detalhar: detalhar,
          situacao: tipoDebito
        }
      });


    try {
      const response = await this.http
        .get<PessoaDebito>(`${this.apiUrl}${chave}/debitos`, { ...requestOptions, params }) 
        .toPromise();
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Requisição abortada');
      } else {
        this.messageService.add({ severity: 'error',  summary: error.error.title, detail: error.error.detail  });
        throw error;
      }
      throw error;
    }
  }
}